import React from "react"
import styled from "@emotion/styled"
import ButtonLink from "../global/ButtonLink"

const Outer = styled.section`
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(32px, auto);
  padding: 160px 0;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
  }
`
const Inner = styled.div`
  grid-column: 2;
  text-align: center;
`
const Title = styled.h1``
const TextContainer = styled.div`
  max-width: 880px;
  margin: 0 auto;
  p {
    margin: 0 auto;
    max-width: ${props => (props.copyWidth ? props.copyWidth : "480px")};
  }
`
const ButtonContainer = styled.div`
  margin-top: 40px;
  display: grid;
  justify-content: center;
`

export default function Hero({
  title,
  content,
  copyWidth,
  buttonLink,
  buttonText,
}) {
  return (
    <Outer>
      <Inner>
        <TextContainer copyWidth={copyWidth}>
          <Title>{title}</Title>
          <p>{content}</p>
        </TextContainer>

        {buttonLink && buttonText && (
          <ButtonContainer>
            <ButtonLink
              to={buttonLink}
              backgroundColorOverride={props => props.theme.primary}
            >
              {buttonText}
            </ButtonLink>
          </ButtonContainer>
        )}
      </Inner>
    </Outer>
  )
}
